import { create } from "zustand";
import { BinanceAccountInfo } from "@/hooks/exchanges/useBinanceBalances";

interface AccountInfoState {
  // Map of account IDs to their account info
  accountInfoMap: Record<string, BinanceAccountInfo | null>;

  // Loading states for each account
  loadingMap: Record<string, boolean>;

  // Error states for each account
  errorMap: Record<string, string | null>;

  // Set account info for a specific account
  setAccountInfo: (
    accountId: string,
    accountInfo: BinanceAccountInfo | null,
  ) => void;

  // Set loading state for a specific account
  setLoading: (accountId: string, loading: boolean) => void;

  // Set error state for a specific account
  setError: (accountId: string, error: string | null) => void;

  // Get account info for a specific account
  getAccountInfo: (accountId: string) => BinanceAccountInfo | null;

  // Get loading state for a specific account
  isLoading: (accountId: string) => boolean;

  // Get error state for a specific account
  getError: (accountId: string) => string | null;
}

export const useAccountInfoStore = create<AccountInfoState>()((set, get) => ({
  accountInfoMap: {},
  loadingMap: {},
  errorMap: {},

  setAccountInfo: (accountId, accountInfo) =>
    set((state) => ({
      accountInfoMap: {
        ...state.accountInfoMap,
        [accountId]: accountInfo,
      },
    })),

  setLoading: (accountId, loading) =>
    set((state) => ({
      loadingMap: {
        ...state.loadingMap,
        [accountId]: loading,
      },
    })),

  setError: (accountId, error) =>
    set((state) => ({
      errorMap: {
        ...state.errorMap,
        [accountId]: error,
      },
    })),

  getAccountInfo: (accountId) => get().accountInfoMap[accountId] || null,

  isLoading: (accountId) => get().loadingMap[accountId] || false,

  getError: (accountId) => get().errorMap[accountId] || null,
}));
